import { https } from 'follow-redirects';
import fs from 'fs';
import { version } from '../package.json'

const types = {
  darwin: 'macos-11',
  linux: 'ubuntu-18.04'
} as Record<string, string>;

async function postinstall() {
  const bridge = fs.createWriteStream("dist/bridge");

  const platform = process.platform as string;

  const type = types[platform];

  if (type === undefined) {
    console.error(`Sorry, appsync-testing does not currently support the ${platform}, please raise a GitHub issue 🙏`);
    
    process.exit(1);
  }

  const url = `https://github.com/WealthWizardsEngineering/appsync-testing/releases/download/v${version}/${type}-bridge`;

  await new Promise((resolve, reject) => {
    https.get(url, (res) => {
      res.pipe(bridge);
      bridge.on('finish', resolve);
      bridge.on('error', (error) => {
        reject(error.message);
        fs.unlinkSync('dist/bridge');
      });
    });
  });

  fs.chmodSync('dist/bridge', '755');
}

postinstall();
